import {BackendDashboardView} from 'components/Backend/Dashboard/View';

// export const title = '後台首頁';

export const orderNum = 0;

export default BackendDashboardView;
